import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input, Form, Spinner, FormGroup, Card, CardBody } from 'reactstrap';
import { FaChevronRight, FaSlash, FaChevronLeft } from 'react-icons/fa';
import { useSearchParams } from 'react-router-dom';
import './Waterways.css';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import WaterwayItemCommonTop from '../ItemPopup/WaterwayItemCommonTop';
import ItemCommonBottom from '../ItemPopup/ItemCommonBottom';
import ItemFooter from '../ItemPopup/ItemFooter';
import Action from '../Action/Action';
import MapView from '../Map/MapView';
import NonMapView from '../ItemsView/NonMapView';
import MaintenancePlan from '../MaintenancePlan/MaintenancePlan';
import WaterwaysItemSpecView from './WaterwaysItemSpecView'
import Validate from '../Validate/Validate';
import { useNavigate, useLocation } from "react-router-dom";
import RiskSummary from '../ItemsView/RiskSummary';
import ItemTypeListViewForMap from '../ItemsView/ItemTypeListViewForMap';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import ItemBasedAction from '../Action/ItemBasedAction'; import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}


const Waterways = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage, pageSection }) => {
    const roleName = localStorage.getItem("roleName"); const [imageUploadList, setImageUploadList] = useState([]);
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(false);
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [isNextButtonVisible, setIsNextButtonVisible] = useState(false); const { height, width } = useWindowDimensions();
    const [searchParams, setSearchParams] = useSearchParams(); const [toggleSwitch, setToggleSwitch] = useState('map & details'); const [isThisPageCompleted, setIsThisPageCompleted] = useState(false); const [actionsCount, setActionsCount] = useState(0);
    const { state } = useLocation(); const [saving, setSaving] = useState(''); const [itemDeletesaving, setItemDeleteSaving] = useState('');
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState({ FencingPercentage: '' });
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [loading, setLoading] = useState(true);
    const [waterway, setWaterway] = useState({
        masterWaterwayItemList:[],
        outlineList: [], itemList: [], itemTypes: [], uniqueItemTypes: [], Section: pageSection.Section, SectionName: 'Waterways',
        itemFieldTypes: [], waterwayWidthList: [], percentageFencedList: [], averageRiparianMarginPlantedList: [], SectionObj: {}, isWizardCompleted: false, percentageOfLengthRiparianPlantedList: [],
        outlineCenter: {}, farmCenterTypeModel: {}, outlineItemTypes: [], sectionComment: '', isMapOnly: pageSection.IsMapOnly, isMapRisk: pageSection.IsMapRisk
    });
    const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0, isSmallEnterpriseShow: false })
    const [gisLayerDetails, setGISLayerDetails] = useState({ showGISLayer: false, gisLayerList: [] })
    const [gisLayerStockExclusionLandSlopeDetails, setGISLayerStockExclusionLandSlopeDetails] = useState({ showGISLayer: false, gisLayerList: [] })
    const [typeid, setTypeId] = useState(0);
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false, joinNCLUs: false,
        isFarmOutlineEditable: false, zoomLevel: 15, polyType: '', itemsEditable: false, highlighteditemId: 0, isClear: false,showLabel:false
    });
    const [riskLookupList, setRiskLookupList] = useState({ riskList: [], categoryList: [], enterpriseTypes: [], luenterpriseTypes: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], tempActivitySubGroups: [], LUEnterpriseTypes: [] });
    const [itemPopup, setItemPopup] = useState({ showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: 0, markertype: '', canArchive: true,isMaster:false });
    const [itemPopupHeader, setItemPopupHeader] = useState({
        page: 'Waterways', lmu: '', LMUId: 0, itemTypeName: '', LMUIds: '',
        itemTypeId: 0, Name: '', isDragged: false, Description: '', color: "#21b546", isEdited: false, itemTypeDescription: ''
    });
    const [itemPopupMaptype, setItemPopupMaptype] = useState({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', radius: 0.0 });
    const [alertPopup, setAlertPopup] = useState({ showAlertPopup: false, message: '', alertId: 0, isDisregarded: false, disregardDescription: '', alertName: '' });
    const [alertList, setAlertList] = useState([]);
    const [itemPopupBiodiversity, setItemPopupBiodiversity] = useState({ isVisible: false, isItemToBiodiversity: false, biodiversityComment: '' });
    const [itemPopupRisk, setItemPopupRisk] = useState({
        isRisk: 'No', riskId: [], riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', showEnterprise: true, category: '', significance: ''
    });
    const [itemPopupAchievements, setItemPopupAchievements] = useState({ isAchievementsNotes: false, achievementsComment: '', isExpand: false });

    const [itemDeletePopup, setItemDeletePopup] = useState({ showItemDeletePopup: false, itemId: 0 });
    const [actionPopup, setActionPopup] = useState({ isHavingItemBasedAction: false, showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [wholeFarmActionPopup, setWholeFarmActionPopup] = useState({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [maintenancePlanPopup, setMaintenancePlanPopup] = useState({ showMaintenancePlanPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });

    const [itemPopupItemField, setItemPopupItemField] = useState({
        itemTypeId: 0,
        itemFieldTypes: []
    });
    const [itemPopupItemSepcQ, setItemPopupItemSepcQ] = useState({
        IsBoundaryPresent: false,
        IsFenced: false,
        IsFencingNotReq : false,
        FencingPercentage: 0,
        IsRiparianPlanted: false,
        RiprianAvg: 0,
        WaterwayWidth: 0,
        BridgedWaterCrossingsControls: '',
        CulvertedCrossingsControls: '',
        IsFreshwaterSiteofSignificance: false,
        StemCountPerHA: 0, IsFishScreen: false, PercentageOfLengthRiparianPlanted: 0, PercentageGrassRiparianMargin: 0, TypeOfRiparianPlanting: '',
        PercentageWetlandPlanted: 0, WetlandPlanted: '', IsThisRecognisedSignificantWetland: '',
    });

    const [toggleItemTypeListState, setToggleItemTypeListState] = useState({ isOpen: false, isIconUp: false });
    const [toggleItemTypeState, setToggleItemTypeState] = useState({ itemTypeId: 0, isOpen: false, isIconUp: false, uniqueItemTypeName: "" });
    const [toggleItemState, setToggleItemState] = useState({ itemId: 0, isOpen: false, isIconUp: false });
    const [riskSummaryPopup, setRiskSummaryPopup] = useState({ showriskSummary: false });

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [toggleChildItemState, setToggleChildItemState] = useState({ itemId: 0, isOpen: false, isIconUp: false });
    const handleChildItemToggle = (itemId, isOpen, isIconUp) => {
        setToggleChildItemState({ ...toggleChildItemState, itemId: itemId, isOpen: isOpen, isIconUp: isIconUp })
    }
    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/waterways/GetWaterway/', {
                params: {
                    farmId: farmId
                }
            }
            );
            const itemList = response.data.itemList;
            itemList.forEach((item) => {
                item.nonContiguousItems = [];
                itemList.map(nc => {
                    if (nc.waterwayItemId === item.itemId) {
                        item.nonContiguousItems.push(nc);
                    }
                })

            })
            if (response.data.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                if (section.length > 0) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            if (response.data.wizard.isWaterwaysCrossingsRiskSaved) {
                setIsThisPageCompleted(true);
            }
            else {
                setIsThisPageCompleted(false);
            }
            setActionsCount(response.data.actionCount);
            setShow_HistoricalActions(response.data.show_HistoricalActions);
            setShow_SectionComment(response.data.show_SectionComment);
            setWaterway({
                ...waterway, outlineList: response.data.outlineList, itemList: response.data.itemList, itemTypes: response.data.itemTypes, uniqueItemTypes: response.data.uniqueItemTypes, itemFieldTypes: response.data.itemFieldList
                , waterwayWidthList: response.data.waterwayWidthList,
                percentageFencedList: response.data.percentageFencedList, averageRiparianMarginPlantedList: response.data.averageRiparianMarginPlantedList,
                SectionObj: response.data.section, isWizardCompleted: response.data.isFWFPCompleted, percentageOfLengthRiparianPlantedList: response.data.percentageOfLengthRiparianPlantedList, outlineCenter: response.data.outlineCenter, farmCenterTypeModel: response.data.farmCenterTypeModel
                , outlineItemTypes: response.data.outlineItemTypes, sectionComment: response.data.sectionComment,
                masterWaterwayItemList: response.data.masterWaterwayList
            });
            setMasterWaterwayItemList(response.data.masterWaterwayList)
            const content = ContentState.createFromBlockArray(convertFromHTML(response.data.sectionComment == null ? '' : response.data.sectionComment))
            setEditorState(EditorState.createWithContent(content));
            setRiskLookupList({
                ...riskLookupList, riskList: response.data.riskList, enterpriseTypes: response.data.riskModel.enterpriseTypes, luenterpriseTypes: [], contaminants: response.data.riskModel.contaminants, riskDataGroups: response.data.riskModel.riskDataGroups
                , activityGroups: response.data.riskModel.activityGroups, activitySubGroups: [], tempActivitySubGroups: response.data.riskModel.activitySubGroups, LUEnterpriseTypes: response.data.riskModel.luEnterpriseTypeList,
                categoryList: response.data.riskModel.categoryList
            })
            setGISLayerDetails({ ...gisLayerDetails, gisLayerList: response.data.gisLayerList });
            setGISLayerStockExclusionLandSlopeDetails({ ...gisLayerStockExclusionLandSlopeDetails, gisLayerList: response.data.gisLayerList_StockExclusionLandSlope });
            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel, polyType: '' });
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.islargeEnterprise, LMUList: response.data.lmuItemList })
            setLoading(false);
            setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: !response.data.isFWFPCompleted, isIconUp: !response.data.isFWFPCompleted })
            if (state != null) {
                const { itemId, actionId, navigateFrom } = state;
                navigate(state.pathname, { replace: true });
                if (navigateFrom == "Actions") {
                    handleNavigateOpenActionPopup(itemId, actionId, response.data);
                }
                else {
                    editMapItemFromNavigation(itemId, response.data, navigateFrom)
                }
            }
            let search = window.location.search;
            let params = new URLSearchParams(search);
            let navigateFrom = params.get('navigateFrom');
            if (navigateFrom == 'Actions') {
                let actionId = params.get('actionId');
                let itemId = params.get('itemId');
                let isWholeFarmAction = params.get('isWholeFarmAction');
                if (searchParams.has('actionId')) {
                    searchParams.delete('actionId');
                    setSearchParams(searchParams);
                }
                if (searchParams.has('itemId')) {
                    searchParams.delete('itemId');
                    setSearchParams(searchParams);
                }
                if (searchParams.has('isWholeFarmAction')) {
                    searchParams.delete('isWholeFarmAction');
                    setSearchParams(searchParams);
                }
                if (searchParams.has('navigateFrom')) {
                    searchParams.delete('navigateFrom');
                    setSearchParams(searchParams);
                }
                if (isWholeFarmAction == 'true') {
                    handleNavigateOpenWholeActionPopup(itemId, actionId, response.data);
                }
                else {
                    handleNavigateOpenActionPopup(itemId, actionId, response.data);
                }
            }
        } catch (err) {
            console.log(err);
        }
    }
    const handleSectionCommentChange = (e) => {
        const { name, value, checked, type } = e.target;
        setWaterway({ ...waterway, sectionComment: value })
    }
    const handleNavigateOpenActionPopup = (itemId, actionId, waterway) => {
        const itemDetails = waterway.itemList.filter(items => items.itemId == itemId)[0];
        setActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: itemDetails.itemTypeId, itemName: itemDetails.name, actionId: actionId });
    };

    const handleNavigateOpenWholeActionPopup = (itemId, actionId, waterway) => {
        setWholeFarmActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: waterway.outlineCenter.itemTypeId, itemName: 'Map Centre', actionId: actionId });
    };

    function refreshPage() {
        setLoading(true);
        setRiskLookupList({ ...riskLookupList, enterpriseTypes: [], luenterpriseTypes: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], tempActivitySubGroups: [], LUEnterpriseTypes: [] });
        setFormErrors({});
        setWaterway({ ...waterway, outlineList: [], itemList: [], itemTypes: [], uniqueItemTypes: [], itemFieldTypes: [], waterwayWidthList: [], averageRiparianMarginPlantedList: [], percentageFencedList: [], percentageOfLengthRiparianPlantedList: [] });
        OnPageload();
    }

    function resetValues() {
        setItemPopup({ showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: 0, markertype: '', canArchive: true, isMaster: false, isMapOnly: pageSection.IsMapOnly });
        setItemPopupHeader({ page: 'Waterways', lmu: '', itemTypeName: '', LMUIds: '', itemTypeId: 0, Name: '', isDragged: false, Description: '', color: "#21b546", itemTypeDescription: '' });
        setItemPopupMaptype({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', radius: 0.0 });
        setItemPopupBiodiversity({ isVisible: false, isItemToBiodiversity: false, biodiversityComment: '' });
        setItemPopupRisk({
            isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', showEnterprise: true, category: '', significance: ''
        });
        setItemPopupAchievements({ isAchievementsNotes: false, achievementsComment: '', isExpand: false });
        setItemDeletePopup({ showItemdeletePopup: false, itemId: 0 });
        setFormErrors({});
        setMapDetails({ ...mapDetails, isClear: true, polyType: '' });
        setIsNonContiguous(false);
        setFormContiguous({ itemId: 0, isNonContiguousItem: false, masterWaterwayItemId: 0, isSameAsMaster: false });
        setImageUploadList([]);
    }

    /* Item select  and Clear*/
    const handleItemClick = (event, typeid, polyType) => {
        setTypeId(typeid);
        setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
        const itemFieldTypesList = waterway.itemFieldTypes.filter(fieldType => fieldType.itemTypeId == typeid);
        setItemPopupItemField({ ...itemPopupItemField, itemTypeId: typeid, itemFieldTypes: itemFieldTypesList });
    }

    function handleClearSelection() {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
        setItemPopupItemField({ ...itemPopupItemField, itemTypeId: 0, itemFieldTypes: [] });
        window.location.reload(true);
    }

    const handleLMUChange = (event) => {
        var lus = '';
        let luArr = [];
        if (typeof event === 'object' && event.constructor === Object) {
            lus = event.value.toString();
        }
        else {
            event.forEach(lmu => {
                luArr.push(lmu.value);
            })
            lus = luArr.join(",");
        }

        if (lus == '') {
            setItemPopupRisk({ ...itemPopupRisk, isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', category: '', significance: '' });
        }
        else if (lus != '') {
            let selectedLUEnterpriseTypes = [];
            var LUEnterpriseTypes = [];//riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == value);
            lus.split(',').forEach(lmu => {
                if (riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == parseInt(lmu)).length > 0) {
                    LUEnterpriseTypes.push(riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == parseInt(lmu)));
                }
            })
            if (LUEnterpriseTypes.length > 0) {
                let LUEnterpriseTypesArray = [];
                LUEnterpriseTypes.forEach(enterpriseArray => {
                    var array = enterpriseArray[0].enterpriseTypeList.split(',');
                    array.forEach(obj => {
                        if (LUEnterpriseTypesArray.filter(x => x == obj).length == 0) {
                            LUEnterpriseTypesArray.push(obj);
                        }
                    })
                });


                //LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                    return LUEnterpriseTypesArray.includes(String(el.value))
                });
                if (selectedLUEnterpriseTypes.length == 0) {
                    selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                        return el.label == 'N/A'
                    });
                }
                var displayEnterprise = false;
                if (selectedLUEnterpriseTypes.filter(x => x.label == 'N/A').length > 0) {
                    if (selectedLUEnterpriseTypes.length == 1) {
                        displayEnterprise = false;
                    }
                    else {
                        displayEnterprise = true;
                    }
                }
                else {
                    displayEnterprise = true;
                }
            }
            setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes })
            setItemPopupRisk({ ...itemPopupRisk, enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', showEnterprise: displayEnterprise, category: '', significance: '' });
        }

        setItemPopupHeader({ ...itemPopupHeader, LMUIds: lus });
    }

    /*ItemPopup value change Handle*/
    const handleItemPopupHeaderChange = (event) => {
        const { name, value, checked, type } = event.target;
        if (name == 'Name') {
            if (event.target.value.length > 60) {
                return false;
            }
        }
        setFormErrors({});
        setItemPopupHeader({ ...itemPopupHeader, [name]: type == 'checkbox' ? checked : value });
    }

    function handleItemPopupBiodiversity(event) {
        const { name, value, checked, type } = event.target;
        setItemPopupBiodiversity({ ...itemPopupBiodiversity, [name]: type == 'checkbox' ? checked : value });
    }

    function handleItemPopupRisk(event) {
        const { name, value, checked, type } = event.target;
        if (name == 'isRisk' && value == 'Yes') {
            setFormErrors({});
            const errors = {};
            if (itemPopupHeader.LMUIds == '') {
                errors.luid = "Please select LU";
                setFormErrors(errors);
            }
            else {
                setItemPopupRisk({ ...itemPopupRisk, [name]: type == 'checkbox' ? checked : value });
            }
        }
        else if (name == 'isRisk' && value == 'No') {
            setItemPopupRisk({ ...itemPopupRisk, isRisk: 'No', category: '', significance: '', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '' });
        }
        else {
            setItemPopupRisk({ ...itemPopupRisk, [name]: type == 'checkbox' ? checked : value });
        }
    }

    const handleMultiSelectEnterpriseChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, enterprises: e });
    }
    const handleMultiSelectRiskChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, riskId: e });
    }
    const handleMultiSelectContaminantChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, contaminants: e });
    }
    const handleMultiSelectCategoryChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, category: e });
    }
    const handleMultiSelectRiskDataGroupChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, riskDataGroups: e });
    }

    const handleMultiSelectActivityGroupChange = (e) => {

        setRiskLookupList({
            ...riskLookupList, activitySubGroups: []
        })

        var selectedActivitySubGroups = [];
        let myArrayFiltered = [];
        if (itemPopupRisk.activitySubGroups != undefined && itemPopupRisk.activitySubGroups.length > 0) {
            selectedActivitySubGroups = itemPopupRisk.activitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
            myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        else {
            myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        setRiskLookupList({
            ...riskLookupList, activitySubGroups: myArrayFiltered
        })
        setItemPopupRisk({ ...itemPopupRisk, activityGroups: e, activitySubGroups: selectedActivitySubGroups });
    }

    const handleMultiSelectActivitySubGroupChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, activitySubGroups: e });
    }

    function handleItemPopupAchievements(event) {
        const { name, value, checked, type } = event.target;
        setItemPopupAchievements({ ...itemPopupAchievements, [name]: type == 'checkbox' ? checked : value });
    }

    const handleItemSepcValueChange = (event) => {
        const { name, value, checked, type } = event.target;
        setItemPopupItemSepcQ({ ...itemPopupItemSepcQ, [name]: type == 'checkbox' ? checked : value });
        if (name == 'FencingPercentage' && value == '136') {
            setItemPopupHeader({
                ...itemPopupHeader, color: '#0000FF'
            });
        }
    }

    const handleLMUSelectChange = (event) => {
        const { name, value, checked, type } = event.target;
        setLargeEnterpriseDetails({ ...largeEnterpriseDetails, [name]: type == 'checkbox' ? checked : value });
    }

    /*Item Add and Submit*/
    function addMapItem(mapItem, maptype) {
        let path, area = 0.0, perimeter = 0.0, coordinates = '', radius = 0.0;
        var selectedItemType = waterway.itemTypes.filter(item => item.id == typeid)[0];
        const ItemTypeName = selectedItemType.name;
        const isBiodiversityReq = selectedItemType.isBiodiversityReq == true ? true : false;
        let lmuId = largeEnterpriseDetails.selectedLMUId;
        const defaultColour = selectedItemType.defaultColour != null && selectedItemType.defaultColour != '' ? selectedItemType.defaultColour : "#21b546";

        /***********LMU Identification*************/
        if (maptype == 'marker') {
            largeEnterpriseDetails.LMUList.map((obj) => {
                const outlineCoordinates = obj.mapCoordinates.split(':');
                const outlinepositions = [];
                outlineCoordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    outlinepositions.push(pos);
                })
                const outlinePolygon = new window.google.maps.Polygon({
                    paths: outlinepositions
                });
                const pos = { lat: mapItem.getPosition().lat(), lng: mapItem.getPosition().lng() }

                const inside = window.google.maps.geometry.poly.containsLocation(
                    pos,
                    outlinePolygon
                ) ? true : false;
                if (inside) {
                    lmuId = obj.id;
                }
            });
        }
        /***********LMU Identification*************/

        if (maptype == 'marker') {

            coordinates = mapItem.getPosition().lat().toFixed(6) + ", " + mapItem.getPosition().lng().toFixed(6);
        }
        else if (maptype == 'polygon') {
            path = mapItem.getPath();
            area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
        }
        else if (maptype == 'polyline') {
            path = mapItem.getPath();
            area = 0;
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
            if (path.getArray().length <= 1) {
                toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                resetValues();
                return false;
            }
        }
        else if (maptype == 'circle') {
            coordinates = mapItem.getCenter().lat().toFixed(6) + ", " + mapItem.getCenter().lng().toFixed(6);
            radius = mapItem.radius.toFixed(2);
            const Pi = 3.14;
            area = ((radius * radius * Pi) / 10000).toFixed(1);
            perimeter = ((2 * Pi * radius) / 1000).toFixed(1);
        }
        let selectedLUEnterpriseTypes = [];
        if (lmuId != 0) {
            var LUEnterpriseTypes = riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == lmuId);
            if (LUEnterpriseTypes.length != 0) {
                let LUEnterpriseTypesArray = [];

                LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                    return LUEnterpriseTypesArray.includes(String(el.value))
                });
                if (selectedLUEnterpriseTypes.length == 0) {
                    selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                        return el.label == 'N/A'
                    });
                }
            }
        }

        setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes })

        setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: mapItem, farmId: farmId, id: 0, itemId: 0, markertype: maptype, canArchive: true, isMaster: false, isMapOnly: pageSection.IsMapOnly });
        setItemPopupMaptype({ ...itemPopupMaptype, markertype: maptype, area: area, perimeter: perimeter, coordinates: coordinates, radius: radius });
        setItemPopupHeader({ ...itemPopupHeader, itemTypeName: ItemTypeName, LMUIds: lmuId.toString(), itemTypeId: typeid, LMUId: lmuId, Name: '', isDragged: false, Description: '', color: defaultColour, isEdited: false, itemTypeDescription: selectedItemType.itemDescription });
        setItemPopupBiodiversity({ ...itemPopupBiodiversity, isVisible: isBiodiversityReq });
        setItemPopupAchievements({ ...itemPopupAchievements, isExpand: false });
        setItemPopupItemSepcQ({
            ...itemPopupItemSepcQ, IsBoundaryPresent: false, IsFenced: false, IsFencingNotReq: false, FencingPercentage: 0, IsRiparianPlanted: false, RiprianAvg: 0, WaterwayWidth: 0, BridgedWaterCrossingsControls: '',
            CulvertedCrossingsControls: '', IsFreshwaterSiteofSignificance: false, StemCountPerHA: 0, IsFishScreen: false, PercentageOfLengthRiparianPlanted: 0, PercentageGrassRiparianMargin: 0, TypeOfRiparianPlanting: '',
            PercentageWetlandPlanted: 0, WetlandPlanted: '', IsThisRecognisedSignificantWetland: '',
        });
        setImageUploadList([]);
    }

    const handleItemSubmit = async (event) => {
        setFormErrors({});
        const errors = {};
        setSaving(true);
        let enterprises = '';
        let contaminants = '';
        let riskDataGroups = '';
        let activityGroups = '';
        let activitySubGroups = '';
        let category = '';
        var RiskId = 0;
        var RiskIds = '';
        if (itemPopupRisk.isRisk == "Yes") {
            if (itemPopupRisk.riskId == 0 || itemPopupRisk.riskId == null || itemPopupRisk.riskId == undefined) {
                errors.riskSelection = "This is mandatory!";
            }
            else {
                if (typeof itemPopupRisk.riskId === 'object' && itemPopupRisk.riskId.constructor === Object) {
                    RiskIds = itemPopupRisk.riskId.value.toString();
                }
                else if (Array.isArray(itemPopupRisk.riskId)) {
                    let riskArr = [];
                    itemPopupRisk.riskId.forEach(type => {
                        riskArr.push(type.value);
                    })
                    var riskValue = riskArr.join(",");
                    RiskIds = riskValue;
                }
            }
        }
        if (itemPopupHeader.LMUIds == null || itemPopupHeader.LMUIds == '' || itemPopupHeader.LMUIds == undefined || itemPopupHeader.LMUIds == '0') {
            errors.luid = "This is mandatory!";
        }
        if (formContiguous.isNonContiguousItem) {
            if (formContiguous.masterWaterwayItemId == 0) {
                errors.masterWaterwayItemId = "This is mandatory!";
            }
        }
        setFormErrors(errors);
        if (Object.keys(errors).length == 0) {
            let form = {
                Id: itemPopup.id,
                MapMarkerType: itemPopup.markertype,
                FarmId: itemPopup.farmId,
                ItemId: itemPopup.itemId,
                Name: itemPopupHeader.Name,
                IsDragged: itemPopupHeader.isDragged,
                Description: itemPopupHeader.Description,
                Colour: itemPopupHeader.color,
                LMUId: itemPopupHeader.LMUId,
                ItemTypeId: itemPopupHeader.itemTypeId,
                Area: itemPopupMaptype.area,
                Length: itemPopupMaptype.perimeter,
                MapCoordinates: itemPopupMaptype.coordinates,
                IsAddsToBioDiversity: itemPopupBiodiversity.isItemToBiodiversity,
                BioDiversityComment: itemPopupBiodiversity.biodiversityComment,
                IsItemHaveAnyRisk: itemPopupRisk.isRisk,
                RiskDescription: itemPopupRisk.riskComment,
                IsAchievementOfNote: itemPopupAchievements.isAchievementsNotes,
                AchievementOfNoteComments: itemPopupAchievements.achievementsComment,
                IsBoundaryPresent: itemPopupItemSepcQ.IsBoundaryPresent,
                IsFenced: itemPopupItemSepcQ.IsFenced,
                IsFencingNotReq: itemPopupItemSepcQ.IsFencingNotReq,
                FencingPercentage: itemPopupItemSepcQ.FencingPercentage,
                IsRiparianPlanted: itemPopupItemSepcQ.IsRiparianPlanted,
                RiprianAvg: itemPopupItemSepcQ.RiprianAvg,
                WaterwayWidth: itemPopupItemSepcQ.WaterwayWidth,
                BridgedWaterCrossingsControls: itemPopupItemSepcQ.BridgedWaterCrossingsControls,
                CulvertedCrossingsControls: itemPopupItemSepcQ.CulvertedCrossingsControls,
                IsFreshwaterSiteofSignificance: itemPopupItemSepcQ.IsFreshwaterSiteofSignificance,
                StemCountPerHA: itemPopupItemSepcQ.StemCountPerHA,
                userId: userId,
                IsEdited: itemPopupHeader.isEdited,
                radius: itemPopupMaptype.radius,
                IsFishScreen: itemPopupItemSepcQ.IsFishScreen,
                PercentageOfLengthRiparianPlanted: itemPopupItemSepcQ.PercentageOfLengthRiparianPlanted,
                PercentageGrassRiparianMargin: itemPopupItemSepcQ.PercentageGrassRiparianMargin,
                PercentageWetlandPlanted: itemPopupItemSepcQ.PercentageWetlandPlanted,
                WetlandPlanted: itemPopupItemSepcQ.WetlandPlanted,
                IsThisRecognisedSignificantWetland: itemPopupItemSepcQ.IsThisRecognisedSignificantWetland,
                TypeOfRiparianPlanting: itemPopupItemSepcQ.TypeOfRiparianPlanting,
                ActivityIds: enterprises,
                ContaminantIds: contaminants,
                RiskDataGroupIds: riskDataGroups,
                ActivityGroupIds: activityGroups,
                ActivitySubGroupIds: activitySubGroups,
                RiskLikelihood: itemPopupRisk.likelihood,
                RiskImpact: itemPopupRisk.impact,
                Category: category,
                Significance: itemPopupRisk.significance,
                LMUIds: itemPopupHeader.LMUIds,
                RiskIds: RiskIds,
                IsConnectedToAnotherWaterway: formContiguous.isNonContiguousItem,
                WaterwayItemId: formContiguous.masterWaterwayItemId, ImageUploadList: []
            }
            for (var i = 0; i < imageUploadList.length; i++) {
                var obj = {};
                obj.Id = imageUploadList[i].id;
                obj.ImageDetail = imageUploadList[i].imageDetail;
                obj.ImageName = imageUploadList[i].imageName;
                obj.ImagePhysicalName = imageUploadList[i].imagePhysicalName;
                obj.ImagePath = imageUploadList[i].imagePath;
                form.ImageUploadList.push(obj);
            }
            const errors = {};
            if (Object.keys(errors).length == 0 && !Validate(form)) {
                try {
                    const response = await apiPost(
                        '/api/waterways/UpdateWaterway/', JSON.stringify(form),
                        {
                            headers: { 'Content-Type': 'application/json' },
                            withCredentials: true
                        });
                    if (response.data != null) {
                        if (response.data.message == 'Added') {
                            await refreshItemDetails();
                            setSaving(false);
                            toast.success("Item details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                            handleItemPopupClose();
                        }
                        else {
                            await refreshItemDetails();
                            setSaving(false);
                            toast.success("Item details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                            handleItemPopupClose();
                        }
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            }
            else {
                setSaving(false);
            }
        }
        else {
            setSaving(false);
        }
    }

    const refreshItemDetails = async () => {
        const response = await apiGet(
            '/api/waterways/GetWaterway/', {
            params: {
                farmId: farmId
            }
        }
        );
        const itemList = response.data.itemList;
        setMasterWaterwayItemList(response.data.masterWaterwayList)
        itemList.forEach((item) => {
            item.nonContiguousItems = [];
            itemList.map(nc => {
                if (nc.waterwayItemId === item.itemId) {
                    item.nonContiguousItems.push(nc);
                }
            })

        })
        setWaterway({
            ...waterway, itemList: response.data.itemList, outlineCenter: response.data.outlineCenter
        });
        setActionsCount(response.data.actionCount);
    }

    function handleItemPopupClose() {
        resetValues();
    }

    const handleMapItemEdited = (itemId, type, strValue) => {
        let name = '';
        let value = '';
        if (type == "cricleCenterChanges") {
            name = 'mapCoordinates';
            value = strValue.lat().toFixed(6) + ", " + strValue.lng().toFixed(6);
        }
        else if (type == "cricleRadiusChanges") {
            name = 'radius';
            value = parseFloat(strValue.toFixed(2));

        }
        else if (type == "polygonBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {
                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }
        else if (type == "polylineBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {
                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }

        const itemList = waterway.itemList.map(item =>
            item.itemId === itemId
                ? { ...item, [name]: value, isEdited: true }
                : item
        )
        setWaterway({ ...waterway, itemList: itemList });
    }

    /*Item Edit and Submit*/
    function editMapItem(mapItem, itemId, isDragged) {
        const itemDetails = waterway.itemList.filter(items => items.itemId == itemId)[0];
        const ItemTypeName = waterway.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].name;
        const ItemDescription = waterway.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].itemDescription;
        const isNonContiguousItem = itemDetails.isConnectedToAnotherWaterway == null || itemDetails.isConnectedToAnotherWaterway == false || itemDetails.isConnectedToAnotherWaterway == undefined ? false : true
        let coordinates = itemDetails.mapCoordinates;
        if (isDragged) {
            coordinates = mapItem.latLng.lat().toFixed(6) + ", " + mapItem.latLng.lng().toFixed(6);
        }

        let area = 0.0, perimeter = 0.0;
        if (itemDetails.isEdited == true) {
            if (itemDetails.mapMarkerType == "circle") {
                const Pi = 3.14;
                area = ((itemDetails.radius * itemDetails.radius * Pi) / 10000).toFixed(1);
                perimeter = ((2 * Pi * itemDetails.radius) / 1000).toFixed(1);
            }
            else if (itemDetails.mapMarkerType == "polygon") {
                const Coordinates = coordinates.split(':');
                const positions = [];
                Coordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    positions.push(pos);
                })
                const tempPolygon = new window.google.maps.Polygon({
                    paths: positions
                });

                let path = tempPolygon.getPath();
                area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
                perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            }
            else if (itemDetails.mapMarkerType == "polyline") {
                const Coordinates = coordinates.split(':');
                const positions = [];
                Coordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    positions.push(pos);
                })

                const tempPolyline = new window.google.maps.Polyline({
                    paths: positions
                });

                let path = tempPolyline.paths;
                area = itemDetails.area;
                perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
                if (path.length <= 1) {
                    toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    resetValues();
                    return false;
                }
            }
        }
        else {
            area = itemDetails.area;
            perimeter = itemDetails.length;
        }

        const isBiodiversityReq = waterway.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].isBiodiversityReq == true ? true : false;
        if (itemDetails != null) {
            setItemPopup({
                ...itemPopup, showItemPopup: true, mapitem: mapItem, farmId: farmId, id: itemDetails.id, itemId: itemDetails.itemId, markertype: itemDetails.mapMarkerType, canArchive: itemDetails.canArchive,
                isMaster: itemDetails.nonContiguousItems.length > 0 ? true : false, isMapOnly: pageSection.IsMapOnly
            });
            setItemPopupMaptype({ ...itemPopupMaptype, markertype: itemDetails.mapMarkerType, area: area, perimeter: perimeter, coordinates: coordinates, radius: itemDetails.radius });
            setItemPopupHeader({
                ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: itemDetails.itemTypeId, LMUId: itemDetails.lmuId == null ? 0 : itemDetails.lmuId, LMUIds: itemDetails.lmuIds == null ? '' : itemDetails.lmuIds
                , Name: itemDetails.name, isDragged: isDragged, Description: itemDetails.description, color: itemDetails.colour, isEdited: itemDetails.isEdited, itemTypeDescription: ItemDescription
            });
            setItemPopupBiodiversity({ ...itemPopupBiodiversity, isVisible: isBiodiversityReq, isItemToBiodiversity: itemDetails.isAddsToBioDiversity, biodiversityComment: itemDetails.bioDiversityComment });


            let enterpriseTypes = []
            if (itemDetails.activityIds != "" && itemDetails.activityIds != null) {
                let enterpriseTypesArray = [];

                enterpriseTypesArray = itemDetails.activityIds.split(',');

                riskLookupList.enterpriseTypes.map(type => {
                    if (enterpriseTypesArray.includes(String(type.value))) {
                        enterpriseTypes.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let categoryIds = []
            if (itemDetails.category != "" && itemDetails.category != null) {
                let categoryArray = [];

                categoryArray = itemDetails.category.split(',');

                riskLookupList.categoryList.map(type => {
                    if (categoryArray.includes(String(type.value))) {
                        categoryIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let ContaminantIds = []
            if (itemDetails.contaminantIds != "" && itemDetails.contaminantIds != null) {
                let ContaminantIdsArray = [];

                ContaminantIdsArray = itemDetails.contaminantIds.split(',');

                riskLookupList.contaminants.map(type => {
                    if (ContaminantIdsArray.includes(String(type.value))) {
                        ContaminantIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let riskDataGroups = []
            if (itemDetails.riskDataGroupIds != "" && itemDetails.riskDataGroupIds != null) {
                let RiskDataGroupIdsArray = [];

                RiskDataGroupIdsArray = itemDetails.riskDataGroupIds.split(',');

                riskLookupList.riskDataGroups.map(type => {
                    if (RiskDataGroupIdsArray.includes(String(type.value))) {
                        riskDataGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let activityGroups = []
            if (itemDetails.activityGroupIds != "" && itemDetails.activityGroupIds != null) {
                let ActivityGroupIdsArray = [];

                ActivityGroupIdsArray = itemDetails.activityGroupIds.split(',');

                riskLookupList.riskDataGroups.map(type => {
                    if (ActivityGroupIdsArray.includes(String(type.value))) {
                        activityGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            setRiskLookupList({
                ...riskLookupList, activitySubGroups: []
            });

            let myArrayFiltered = [];
            if (activityGroups != undefined && activityGroups.length > 0) {
                myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                    return activityGroups.some((f) => {
                        return f.value === el.parentId;
                    });
                });
            }
            else {
                myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                    return activityGroups.some((f) => {
                        return f.value === el.parentId;
                    });
                });
            }

            let activitySubGroups = []
            if (itemDetails.activitySubGroupIds != "" && itemDetails.activitySubGroupIds != null) {
                let activitySubGroupIdsArray = [];

                activitySubGroupIdsArray = itemDetails.activitySubGroupIds.split(',');

                myArrayFiltered.map(type => {
                    if (activitySubGroupIdsArray.includes(String(type.value))) {
                        activitySubGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let riskIds = []
            if (itemDetails.riskIds != "" && itemDetails.riskIds != null) {
                let riskArray = [];

                riskArray = itemDetails.riskIds.toString().split(',');

                riskLookupList.riskList.map(type => {
                    if (riskArray.includes(String(type.value))) {
                        riskIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            setItemPopupRisk({
                isRisk: itemDetails.isItemHaveAnyRisk, riskComment: itemDetails.riskDescription,
                enterprises: enterpriseTypes, contaminants: ContaminantIds, riskDataGroups: riskDataGroups,
                activityGroups: activityGroups, activitySubGroups: activitySubGroups, likelihood: itemDetails.riskLikelihood, impact: itemDetails.riskImpact, showEnterprise: true,
                category: categoryIds, significance: itemDetails.significance, riskId: riskIds
            });

            let selectedLUEnterpriseTypes = [];
            if (itemDetails.lmuId != 0) {
                var LUEnterpriseTypes = riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == itemDetails.lmuId);
                if (LUEnterpriseTypes.length != 0) {
                    let LUEnterpriseTypesArray = [];

                    LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                    selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                        return LUEnterpriseTypesArray.includes(String(el.value))
                    });
                }
            }

            setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes, activitySubGroups: myArrayFiltered })

            setItemPopupAchievements({ ...itemPopupAchievements, isAchievementsNotes: itemDetails.isAchievementOfNote, achievementsComment: itemDetails.achievementOfNoteComments, isExpand: false });

            const itemFieldTypesList = waterway.itemFieldTypes.filter(fieldType => fieldType.itemTypeId == itemDetails.itemTypeId);
            setItemPopupItemField({ ...itemPopupItemField, itemTypeId: itemDetails.itemTypeId, itemFieldTypes: itemFieldTypesList });

            setItemPopupItemSepcQ({
                IsBoundaryPresent: itemDetails.isBoundaryPresent,
                IsFenced: itemDetails.isFenced,
                IsFencingNotReq: itemDetails.isFencingNotReq,
                FencingPercentage: itemDetails.fencingPercentage,
                IsRiparianPlanted: itemDetails.isRiparianPlanted,
                RiprianAvg: itemDetails.riprianAvg,
                WaterwayWidth: itemDetails.waterwayWidth,
                BridgedWaterCrossingsControls: itemDetails.bridgedWaterCrossingsControls,
                CulvertedCrossingsControls: itemDetails.culvertedCrossingsControls,
                IsFreshwaterSiteofSignificance: itemDetails.isFreshwaterSiteofSignificance,
                StemCountPerHA: itemDetails.stemCountPerHA,
                IsFishScreen: itemDetails.isFishScreen,
                PercentageOfLengthRiparianPlanted: itemDetails.percentageOfLengthRiparianPlanted,
                PercentageGrassRiparianMargin: itemDetails.percentageGrassRiparianMargin,
                PercentageWetlandPlanted: itemDetails.percentageWetlandPlanted,
                WetlandPlanted: itemDetails.wetlandPlanted,
                IsThisRecognisedSignificantWetland: itemDetails.isThisRecognisedSignificantWetland,
                TypeOfRiparianPlanting: itemDetails.typeOfRiparianPlanting,
            });
            setAlertList(itemDetails.alerts);

            setIsNonContiguous(isNonContiguousItem);
            setFormContiguous({ itemId: itemId, isNonContiguousItem: isNonContiguousItem, masterWaterwayItemId: itemDetails.waterwayItemId, isSameAsMaster: false });
        }
    }

    const editMapItemFromNavigation = (itemId, waterway, navigateFrom) => {
        const itemDetails = waterway.itemList.filter(items => items.itemId == itemId)[0];
        const ItemTypeName = waterway.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].name;
        const ItemDescription = waterway.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].itemDescription;
        let coordinates = itemDetails.mapCoordinates;
        const isNonContiguousItem = itemDetails.isConnectedToAnotherWaterway == null || itemDetails.isConnectedToAnotherWaterway == false || itemDetails.isConnectedToAnotherWaterway == undefined ? false : true

        let area = 0.0, perimeter = 0.0;
        if (itemDetails.isEdited == true) {
            if (itemDetails.mapMarkerType == "circle") {
                const Pi = 3.14;
                area = ((itemDetails.radius * itemDetails.radius * Pi) / 10000).toFixed(1);
                perimeter = ((2 * Pi * itemDetails.radius) / 1000).toFixed(1);
            }
            else if (itemDetails.mapMarkerType == "polygon") {
                const Coordinates = coordinates.split(':');
                const positions = [];
                Coordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    positions.push(pos);
                })
                const tempPolygon = new window.google.maps.Polygon({
                    paths: positions
                });

                let path = tempPolygon.getPath();
                area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
                perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            }
            else if (itemDetails.mapMarkerType == "polyline") {
                const Coordinates = coordinates.split(':');
                const positions = [];
                Coordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    positions.push(pos);
                })

                const tempPolyline = new window.google.maps.Polyline({
                    paths: positions
                });

                let path = tempPolyline.paths;
                area = itemDetails.area;
                perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
                if (path.length <= 1) {
                    toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    resetValues();
                    return false;
                }
            }
        }
        else {
            area = itemDetails.area;
            perimeter = itemDetails.length;
        }

        const isBiodiversityReq = waterway.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].isBiodiversityReq == true ? true : false;
        if (itemDetails != null) {
            setItemPopup({
                ...itemPopup, showItemPopup: true, mapitem: [], farmId: farmId, id: itemDetails.id, itemId: itemDetails.itemId, markertype: itemDetails.mapMarkerType, canArchive: itemDetails.canArchive,
                isMaster: itemDetails.nonContiguousItems.length > 0 ? true : false, isMapOnly: pageSection.IsMapOnly
            });
            setItemPopupMaptype({ ...itemPopupMaptype, markertype: itemDetails.mapMarkerType, area: area, perimeter: perimeter, coordinates: coordinates, radius: itemDetails.radius });
            setItemPopupHeader({
                ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: itemDetails.itemTypeId, LMUId: itemDetails.lmuId == null ? 0 : itemDetails.lmuId, LMUIds: itemDetails.lmuIds == null ? '' : itemDetails.lmuIds
                , Name: itemDetails.name, Description: itemDetails.description, color: itemDetails.colour, isEdited: itemDetails.isEdited, itemTypeDescription: ItemDescription
            });
            setItemPopupBiodiversity({ ...itemPopupBiodiversity, isVisible: isBiodiversityReq, isItemToBiodiversity: itemDetails.isAddsToBioDiversity, biodiversityComment: itemDetails.bioDiversityComment });

            let enterpriseTypes = []
            if (itemDetails.activityIds != "" && itemDetails.activityIds != null) {
                let enterpriseTypesArray = [];

                enterpriseTypesArray = itemDetails.activityIds.split(',');

                riskLookupList.enterpriseTypes.map(type => {
                    if (enterpriseTypesArray.includes(String(type.value))) {
                        enterpriseTypes.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let categoryIds = []
            if (itemDetails.category != "" && itemDetails.category != null) {
                let categoryArray = [];

                categoryArray = itemDetails.category.split(',');

                riskLookupList.categoryList.map(type => {
                    if (categoryArray.includes(String(type.value))) {
                        categoryIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let ContaminantIds = []
            if (itemDetails.contaminantIds != "" && itemDetails.contaminantIds != null) {
                let ContaminantIdsArray = [];

                ContaminantIdsArray = itemDetails.contaminantIds.split(',');

                riskLookupList.contaminants.map(type => {
                    if (ContaminantIdsArray.includes(String(type.value))) {
                        ContaminantIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let riskDataGroups = []
            if (itemDetails.riskDataGroupIds != "" && itemDetails.riskDataGroupIds != null) {
                let RiskDataGroupIdsArray = [];

                RiskDataGroupIdsArray = itemDetails.riskDataGroupIds.split(',');

                riskLookupList.riskDataGroups.map(type => {
                    if (RiskDataGroupIdsArray.includes(String(type.value))) {
                        riskDataGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let activityGroups = []
            if (itemDetails.activityGroupIds != "" && itemDetails.activityGroupIds != null) {
                let ActivityGroupIdsArray = [];

                ActivityGroupIdsArray = itemDetails.activityGroupIds.split(',');

                riskLookupList.riskDataGroups.map(type => {
                    if (ActivityGroupIdsArray.includes(String(type.value))) {
                        activityGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            setRiskLookupList({
                ...riskLookupList, activitySubGroups: []
            });

            let myArrayFiltered = [];
            if (activityGroups != undefined && activityGroups.length > 0) {
                myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                    return activityGroups.some((f) => {
                        return f.value === el.parentId;
                    });
                });
            }
            else {
                myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                    return activityGroups.some((f) => {
                        return f.value === el.parentId;
                    });
                });
            }

            let activitySubGroups = []
            if (itemDetails.activitySubGroupIds != "" && itemDetails.activitySubGroupIds != null) {
                let activitySubGroupIdsArray = [];

                activitySubGroupIdsArray = itemDetails.activitySubGroupIds.split(',');

                myArrayFiltered.map(type => {
                    if (activitySubGroupIdsArray.includes(String(type.value))) {
                        activitySubGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let riskIds = []
            if (itemDetails.riskId != "" && itemDetails.riskId != null) {
                let riskArray = [];

                riskArray = itemDetails.riskId.toString().split(',');

                riskLookupList.riskList.map(type => {
                    if (riskArray.includes(String(type.value))) {
                        riskIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            setItemPopupRisk({
                isRisk: itemDetails.isItemHaveAnyRisk, riskComment: itemDetails.riskDescription,
                enterprises: enterpriseTypes, contaminants: ContaminantIds, riskDataGroups: riskDataGroups,
                activityGroups: activityGroups, activitySubGroups: activitySubGroups, likelihood: itemDetails.riskLikelihood, impact: itemDetails.riskImpact, showEnterprise: true,
                category: categoryIds, significance: itemDetails.significance, riskId: riskIds
            });

            let selectedLUEnterpriseTypes = [];
            if (itemDetails.lmuId != 0) {
                var LUEnterpriseTypes = riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == itemDetails.lmuId);
                if (LUEnterpriseTypes.length != 0) {
                    let LUEnterpriseTypesArray = [];

                    LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                    selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                        return LUEnterpriseTypesArray.includes(String(el.value))
                    });
                }
            }

            setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes, activitySubGroups: myArrayFiltered })

            let isExpand = false;
            if (navigateFrom == "Achievements")
                isExpand = true
            setItemPopupAchievements({ ...itemPopupAchievements, isAchievementsNotes: itemDetails.isAchievementOfNote, achievementsComment: itemDetails.achievementOfNoteComments, isExpand: isExpand });

            const itemFieldTypesList = waterway.itemFieldList.filter(fieldType => fieldType.itemTypeId == itemDetails.itemTypeId);
            setItemPopupItemField({ ...itemPopupItemField, itemTypeId: itemDetails.itemTypeId, itemFieldTypes: itemFieldTypesList });

            setItemPopupItemSepcQ({
                IsBoundaryPresent: itemDetails.isBoundaryPresent,
                IsFenced: itemDetails.isFenced,
                IsFencingNotReq: itemDetails.IsFencingNotReq,
                FencingPercentage: itemDetails.fencingPercentage,
                IsRiparianPlanted: itemDetails.isRiparianPlanted,
                RiprianAvg: itemDetails.riprianAvg,
                WaterwayWidth: itemDetails.waterwayWidth,
                BridgedWaterCrossingsControls: itemDetails.bridgedWaterCrossingsControls,
                CulvertedCrossingsControls: itemDetails.culvertedCrossingsControls,
                IsFreshwaterSiteofSignificance: itemDetails.isFreshwaterSiteofSignificance,
                StemCountPerHA: itemDetails.stemCountPerHA,
                IsFishScreen: itemDetails.isFishScreen,
                PercentageGrassRiparianMargin: itemDetails.percentageGrassRiparianMargin,
                PercentageWetlandPlanted: itemDetails.percentageWetlandPlanted,
                WetlandPlanted: itemDetails.wetlandPlanted,
                IsThisRecognisedSignificantWetland: itemDetails.isThisRecognisedSignificantWetland,
                TypeOfRiparianPlanting: itemDetails.typeOfRiparianPlanting,
            });
            setAlertList(itemDetails.alerts);
            setIsNonContiguous(isNonContiguousItem);
            setFormContiguous({ itemId: itemId, isNonContiguousItem: isNonContiguousItem, masterWaterwayItemId: itemDetails.waterwayItemId, isSameAsMaster: false });
        }
    }

    function handleItemEditPopup(itemId) {
        editMapItem([], itemId, false)
    }

    /*Item Delete*/
    function handleItemDeletePopup(itemId) {
        setItemDeletePopup({ showItemDeletePopup: true, itemId: itemId });
    }

    function handleItemDeletePopupClose() {
        setItemDeletePopup({ showItemDeletePopup: false, itemId: 0 });
    }

    function handleAlertPopupOpen(alertName, message) {
        var itemType = waterway.itemTypes.filter(x => x.id == itemPopupHeader.itemTypeId);
        var alert = itemType[0].alertList.filter(x => x.itemFieldName == alertName && x.itemTypeId == itemPopupHeader.itemTypeId);
        setAlertPopup({ ...alertPopup, showAlertPopup: true, message: message, isDisregarded: false, disregardDescription: '', alertId: alert[0].id, alertName: alertName });
    }

    function handleAlertPopupClose() {
        setAlertPopup({ ...alertPopup, showAlertPopup: false });
    }

    const handleAlertPopupSave = async () => {
        var itemId = itemPopup.itemId;
        var alertObj = {
            id: 0, alertId: alertPopup.alertId, itemId: itemId, isDisregarded: alertPopup.isDisregarded, disregardDescription: alertPopup.disregardDescription
        };
        if (itemId != 0) {
            try {
                const response = await apiPost(
                    '/api/waterways/SaveAlert/', JSON.stringify(alertObj),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });
                if (response.data != null) {
                    setFormErrors({ ...formErrors, [alertPopup.alertName]: '' });
                    setAlertList(response.data.content);
                    setAlertPopup({ ...alertPopup, showAlertPopup: false });
                }
            } catch (error) {
                console.error('Error:', error);
            }
        }
        else {
            setFormErrors({ ...formErrors, [alertPopup.alertName]: '' });
            var alertList = [];
            var alert = {
                alertId: alertPopup.alertId, disregardDescription: alertPopup.disregardDescription, id: 0, isDisregarded: alertPopup.isDisregarded, itemId:0
            };
            alertList.push(alert);
            setAlertList(alertList);
            setAlertPopup({ ...alertPopup, showAlertPopup: false });
        }

    }

    const deleteItem = async (event) => {
        setItemDeleteSaving(true);
        const itemid = itemDeletePopup.itemId;
        try {
            const response = await apiGet(
                '/api/waterways/DeleteItem/', {
                params: {
                    itemId: itemid, userId: userId
                }
            }
            );
            if (response.data != null) {
                await refreshItemDetails();
                setItemDeleteSaving(false);
                handleItemDeletePopupClose();
                handleItemPopupClose();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    /*Item- Action Popup handle*/
    function handleOpenActionPopup(itemId, actionId) {
        const itemDetails = waterway.itemList.filter(items => items.itemId == itemId)[0];
        setActionPopup({ isHavingItemBasedAction: itemDetails.isHavingItemBasedAction, showActionPopup: true, itemId: itemId, itemTypeId: itemDetails.itemTypeId, itemName: itemDetails.name, actionId: actionId });
    };

    const handleOpenWholeActionPopup = (itemId, actionId) => {
        setWholeFarmActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: waterway.outlineCenter.itemTypeId, itemName: 'NA', actionId: actionId });
    };

    const handleActionClose = async () => {
        setActionPopup({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    const handleWholeActionClose = () => {
        setWholeFarmActionPopup({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    /*Item- MaintenancePlan Popup handle*/
    function handleOpenMaintenancePlanPopup(itemId) {
        const itemDetails = waterway.itemList.filter(items => items.itemId == itemId)[0];
        setMaintenancePlanPopup({ ...maintenancePlanPopup, showMaintenancePlanPopup: true, itemId: itemId, itemName: itemDetails.name, itemTypeId: itemDetails.itemTypeId, actionId: 0 });
    }

    function handleMaintenancePlanClose() {
        setMaintenancePlanPopup({ ...maintenancePlanPopup, showMaintenancePlanPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    /*handle Toggle for nonMap View*/
    const handleItemTypeListTogole = (isOpen, isIconUp) => {
        setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleItemTypeTogole = (itemTypeId, isOpen, isIconUp, uniqueItemTypeName) => {
        setToggleItemTypeState({ ...toggleItemTypeState, itemTypeId: itemTypeId, isOpen: isOpen, isIconUp: isIconUp, uniqueItemTypeName: uniqueItemTypeName })
    }

    const handleItemTogole = (itemId, isOpen, isIconUp) => {
        setToggleItemState({ ...toggleItemState, itemId: itemId, isOpen: isOpen, isIconUp: isIconUp })
    }

    /*handle Item highlight*/
    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    /*Avoid unwanted page refresh*/

    const handleRiskSummaryClose = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: false })
        window.location.reload(true);
    }

    const handleRiskSummaryOpen = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: true })
    }

    const mapView = useMemo(() => {
        return (
            <MapView width={toggleSwitch == 'map' ? '80vw' : '50vw'}
                height={toggleSwitch == 'map' ? '80vw' : '50vw'}
                itemModel={waterway}
                mapDetails={mapDetails}
                gisLayerDetails={gisLayerDetails}
                gisLayerStockExclusionLandSlopeDetails={gisLayerStockExclusionLandSlopeDetails}
                addMapItem={addMapItem}
                largeEnterpriseDetails={largeEnterpriseDetails}
                editMapItem={editMapItem}
                handleMapItemEdited={handleMapItemEdited}>
            </MapView>
        )
    }, [waterway, mapDetails, largeEnterpriseDetails, gisLayerDetails, gisLayerStockExclusionLandSlopeDetails, toggleSwitch])

    const toggleSwitchChange = (e) => {
        setToggleSwitch(e)
        if (e == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
            document.getElementById('itemTypeListView').style.height = '70vh';
        }
        else if (e == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }

    const itemTypeListView = useMemo(() => {

        return (
            <ItemTypeListViewForMap isWizardCompleted={waterway.isWizardCompleted} Section={waterway.Section}
                itemTypesList={waterway.itemTypes}
                toggleItemTypeListState={toggleItemTypeListState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemTypeListTogole={handleItemTypeListTogole}
            >
            </ItemTypeListViewForMap>
        )
    }, [waterway, largeEnterpriseDetails, waterway.SectionObj, toggleItemTypeListState, toggleItemTypeState, toggleItemState, waterway.outlineCenter])
    const [hideChildren, setHideChildren] = useState({ waterwayItemId: 0, childWaterwayDisplay: 0, ishideChildren: true });
    const handleHideChildrenCheck = (event, waterwayItemId) => {
        const { name, value, checked, type } = event.target;
        let selectedWaterwayItemId = 0;
        let ishideChildren = true;
        if (name == 'childWaterwayDisplay' && value == 1) {
            selectedWaterwayItemId = waterwayItemId;
            ishideChildren = false;
        }
        setHideChildren({ ...hideChildren, waterwayItemId: waterwayItemId, ishideChildren: ishideChildren, childWaterwayDisplay: value });
    }

    const nonMapView = useMemo(() => {
        return (
            <NonMapView show_HistoricalActions={show_HistoricalActions} toggleChildItemState={toggleChildItemState} handleChildItemToggle={handleChildItemToggle} handleHideChildrenCheck={handleHideChildrenCheck} hideChildren={hideChildren} itemModel={waterway} handleSectionCommentChange={handleSectionCommentChange}
                toggleItemTypeListState={toggleItemTypeListState}
                toggleItemTypeState={toggleItemTypeState}
                toggleItemState={toggleItemState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemEditPopup={handleItemEditPopup}
                handleItemDeletePopup={handleItemDeletePopup}
                handleOpenActionPopup={handleOpenActionPopup}
                sectionObj={waterway.SectionObj}
                largeEnterpriseDetails={largeEnterpriseDetails}
                handleLMUSelectChange={handleLMUSelectChange}
                handleItemTypeListTogole={handleItemTypeListTogole}
                handleItemTypeTogole={handleItemTypeTogole}
                handleItemTogole={handleItemTogole} handleOpenWholeActionPopup={handleOpenWholeActionPopup}
                handleItemHighlight={handleItemHighlight} outlineCenter={waterway.outlineCenter}
            ></NonMapView>
        )
    }, [waterway, largeEnterpriseDetails, waterway.SectionObj, toggleItemTypeListState, toggleItemTypeState, toggleItemState, waterway.outlineCenter, handleHideChildrenCheck, hideChildren, toggleChildItemState, handleChildItemToggle])

    const handleGISLayerDetails = (e) => {
        if (e.target.checked) {
            setGISLayerDetails({ ...gisLayerDetails, showGISLayer: true })
            setGISLayerStockExclusionLandSlopeDetails({ ...gisLayerStockExclusionLandSlopeDetails, showGISLayer: false })
        }
        else {
            setGISLayerDetails({ ...gisLayerDetails, showGISLayer: false })
        }

    }

    const handleGISLayerStockExclusionLandSlopeDetails = (e) => {
        if (e.target.checked) {
            setGISLayerDetails({ ...gisLayerDetails, showGISLayer: false })
            setGISLayerStockExclusionLandSlopeDetails({ ...gisLayerStockExclusionLandSlopeDetails, showGISLayer: true })
        }
        else {
            setGISLayerStockExclusionLandSlopeDetails({ ...gisLayerStockExclusionLandSlopeDetails, showGISLayer: false })
        }

    }

    const [checkActionPopup, setCheckActionPopup] = useState({ showPopup: false, section: '', method: '' });
    const handleCheckActionPopupClose = () => {
        setCheckActionPopup({ showPopup: false, section: '', method: '' });
    }
    const handleCheckCalculatorDataPopupConfirm = () => {
        if (checkActionPopup.method == 'handleWizardChanged') {
            handleWizardChanged(checkActionPopup.section);
        }
        else if (checkActionPopup.method == 'handleMoveToNextPage') {
            handleMoveToNextPage(checkActionPopup.section);
        }
        else if (checkActionPopup.method == 'handleWizardChangedBack') {
            handleWizardChangedBack(checkActionPopup.section);
        }
    }
    const checkAction = async(section, method) => {
        if (!isThisPageCompleted && actionsCount == 0) {
            setCheckActionPopup({ showPopup: true, section: section, method: method });
        }
        else {
            await SaveSectionComment();
            if (method == 'handleWizardChanged') {
                handleWizardChanged(section);
            }
            else if (method == 'handleMoveToNextPage') {
                handleMoveToNextPage(section);
            }
            else if (method == 'handleWizardChangedBack') {
                handleWizardChangedBack(section);
            }
        }
    }

    const handlePageChange = async (section, method) => {
        await SaveSectionComment();
        if (method == 'handleWizardChanged') {
            handleWizardChanged(section);
        }
        else if (method == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
        else if (method == 'handleWizardChangedBack') {
            handleWizardChangedBack(section);
        }
    }
    const [savingSectionComment, setSavingSectionComment] = useState('');
    const saveSectionComment = async () => {
        setSavingSectionComment(true);
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/waterways/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response) {
                setSavingSectionComment(false);
            }
        } catch (err) {
            console.log(err);
            setSavingSectionComment(false);
        }
    }
    const SaveSectionComment = async () => {
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/waterways/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });

        } catch (err) {
            console.log(err);
        }
    }

    const handleEditItemClick = (e) => {
        if (e.target.checked) {
            toast.error("ALERT: when editing a shape remember to click inside the shape when finished, or when editing a line double click on the line, to save any changes.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        setMapDetails({ ...mapDetails, isFarmCenterEditable: !mapDetails.itemsEditable, isFarmOutlineEditable: !mapDetails.itemsEditable, itemsEditable: !mapDetails.itemsEditable })
    }

    const CustomToastWithLink = (message) => (
        <div>
            <p>{message}</p>
        </div>
    );
    const showToastMessage = (e, message, customId) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink(message), {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };

    const handleJoinNCLUsClick = (e) => {
        setMapDetails({ ...mapDetails, isFarmCenterEditable: false, isFarmOutlineEditable: false, itemsEditable: false, joinNCLUs: !mapDetails.joinNCLUs })
    }

    const isAddArchiveItem = localStorage.getItem("isAddArchiveItem");
    const [masterWaterwayItemList, setMasterWaterwayItemList] = useState([]);
    const [formContiguous, setFormContiguous] = useState({ itemId: 0, isNonContiguousItem: false, masterWaterwayItemId: 0, isSameAsMaster: false });
    const [isNonContiguous, setIsNonContiguous] = useState(false);
    const [multiItemModal, setMultiItemModal] = useState({ showMultiItemModal: false, itemList: [] });
    const handleMultiItemModalShowHide = () => {
        setMultiItemModal({ ...multiItemModal, showMultiItemModal: !multiItemModal.showMultiItemModal, itemList: [] });
        setIsNonContiguous(false);
        setMasterWaterwayItemList([]);
        setFormContiguous({ isNonContiguousItem: false, isSameAsMaster: false, masterWaterwayItemId: 0 });
        setMapDetails({ ...mapDetails, isClear: true });
    }
    const handleMultiItemSave = async () => {
    }
    const handleFormFieldChange = (e) => {
        const { name, value, checked, type } = e.target;
        const masterWaterwayItemId = parseInt(formContiguous.masterWaterwayItemId);
        
        if (name == "isNonContiguousItem" && checked == true) {
            setFormContiguous({ ...formContiguous, [name]: type == 'checkbox' ? checked : value });
            setIsNonContiguous(true);
        }
        else if (name == "isNonContiguousItem" && checked == false) {
            setFormContiguous({ ...formContiguous, [name]: type == 'checkbox' ? checked : value, masterWaterwayItemId: 0 });
            setIsNonContiguous(false);
        }
        else {
            setFormContiguous({ ...formContiguous, [name]: type == 'checkbox' ? checked : value });
        }
    }
    const editMapMultiItem = (mapItem, selecteditemList) => {
        let masterWaterwayItems = masterWaterwayItemList;
        selecteditemList.forEach(selecteditem => {
            masterWaterwayItems = masterWaterwayItems.filter(item => item.id !== selecteditem);
        })
        if (masterWaterwayItems.length > 0) {
            setMultiItemModal({ ...multiItemModal, showMultiItemModal: true, itemList: selecteditemList });
            setIsNonContiguous(true);
            setFormContiguous({ isNonContiguousItem: true, isSameAsMaster: true, masterWaterwayItemId: 0 });
        }
    }
    
    return (
        <div>
            {!waterway.isMapOnly &&
                <Modal isOpen={checkActionPopup.showPopup}>
                    <ModalHeader toggle={handleCheckActionPopupClose} >Confirm</ModalHeader>
                    <ModalBody>
                        You have not created any actions on this page. Are you sure you wish to continue?
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleCheckCalculatorDataPopupConfirm} color="primary">
                            Yes
                        </Button>{' '}
                        <Button color="danger" onClick={handleCheckActionPopupClose}>No</Button>
                    </ModalFooter>
                </Modal>
            }
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{waterway.SectionName}</h3></Col>
                <Col>
                    {!loading &&
                        <>
                        {waterway.isMapOnly &&
                                <>
                                    {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                        <>
                                <Button className="float-end btn-next-page" onClick={(section) => handleWizardChanged(waterway.Section, 'handleWizardChanged')}>Next <FaChevronRight /> </Button>
                                        </>
                                    }
                                    {roleName != 'Admin' && saveRightsForNonItemFieldsAndTables == 'false' && isNextButtonVisible &&
                                        <>
                                <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(waterway.Section, 'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                                        </>
                                    }
                                </>
                            }
                        {!waterway.isMapOnly &&
                                <>
                                    {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                        <>
                                <Button className="float-end btn-next-page" onClick={(section) => checkAction(waterway.Section, 'handleWizardChanged')}>Next <FaChevronRight /> </Button>
                                        </>
                                    }
                                    {roleName != 'Admin' && saveRightsForNonItemFieldsAndTables == 'false' && isNextButtonVisible &&
                                        <>
                                <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(waterway.Section, 'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                                        </>
                                    }
                                </>
                            }
                        <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(waterway.Section, 'handleWizardChangedBack')}>Back <FaChevronLeft /> </Button>
                        </>
                    }
                </Col>
                
            </Row>
            <br/>
            {loading ? <SpinnerContainer /> :
                <div>
                    <Row style={{ marginTop: '35px' }}>
                        <Col id='mapView'>
                            <Row className="map-layer">
                                <Col>
                                    <Row>
                                        <Col sm="3"> {toggleSwitch == 'map & details' &&
                                            <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                                <img src="/images/button-details_expand.png" className="card_icon" ></img>
                                            </Button>
                                        }
                                            {toggleSwitch == 'map' &&
                                                <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                    <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                                </Button>
                                            }
                                        </Col>
                                        <Col sm="1"></Col>
                                        <Col sm="8">
                                            <div className="map-item-edit-div">
                                                <Label className="map-checkbox-label">Show LU layer</Label>
                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={largeEnterpriseDetails.isSmallEnterpriseShow} onChange={(e) => setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isSmallEnterpriseShow: !largeEnterpriseDetails.isSmallEnterpriseShow })} name="isSmallEnterpriseShow" id="isSmallEnterpriseShow" />&nbsp;&nbsp;
                                                <Label className="map-checkbox-label">Edit Item</Label>
                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.itemsEditable} onChange={(e) => handleEditItemClick(e)} name="isItemEdit" id="isItemEdit" />&nbsp;&nbsp;
                                                <Label className="map-checkbox-label">Show Label</Label>
                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.showLabel} onChange={(e) => setMapDetails({ ...mapDetails, showLabel: !mapDetails.showLabel })} name="showLabel" id="showLabel" />&nbsp;&nbsp;
                                                {/*<Label className="map-checkbox-label">Combine Land Units</Label>*/}
                                                {/*<Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.joinNCLUs} onChange={(e) => handleJoinNCLUsClick(e)} name="isJoinLU" id="isJoinLU" />&nbsp;&nbsp;*/}
                                            </div>
                                        </Col>
                                    </Row>
                                    {mapView}
                                </Col>
                            </Row>
                        </Col>
                        <Col id="itemTypeListView" style={{ display: toggleSwitch == 'map' ? 'block' : 'none', height: "70vh", overflowY: "scroll", width: "20vw" }}>
                            <Row>
                                <Col>
                                    <Card className="cardNonLeftRadius">
                                        <CardBody>
                                            <Row>
                                                <Col>
                                                    <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                                        <Row>
                                                            <Col>
                                                                <Row>
                                                                    {waterway.isMapOnly &&
                                                                        <Col>
                                                                            <h4>Identify Waterways</h4>
                                                                        </Col>
                                                                    }
                                                                    {!waterway.isMapOnly &&
                                                                        <Col>
                                                                            <h4>Waterways</h4>
                                                                        </Col>
                                                                    }
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="8">
                                                                <Row>
                                                                    <Col>
                                                                        <label className=""><b>Definitions of waterways:</b></label>
                                                                    </Col>
                                                                </Row>
                                                                <Row >
                                                                    <Col  >
                                                                        <ul className="external-map-sub">
                                                                            <li>Ephemeral – an area where water only flows during and shortly after rainfall, e.g. ditch that is dry most of the time, swale.</li>
                                                                            <li>Intermittent – a waterway that ceases to flow for some periods of the year or at least twice every 5 years.</li>
                                                                            <li>Perennial – a waterway that is full or continues to flow throughout the year for all or most years.</li>
                                                                            <li>Groundwater - Groundwater is the water present beneath Earth's surface.</li>
                                                                        </ul>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col>
                                                                <Row>
                                                                    <Col>
                                                                        <label className="external-map-title"><b>External Map Layers</b>&nbsp;&nbsp;&nbsp;
                                                                            <img className="featureIcon" src="/images/info_button_dk.png" data-tooltip-id="my-tooltip-29" onClick={(e) => e.stopPropagation()} /></label>
                                                                        <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                                                            id="my-tooltip-29"
                                                                            place="top"
                                                                            variant="info"
                                                                            render={({ content, activeAnchor }) => (
                                                                                <>
                                                                                    <Row>
                                                                                        <Col>
                                                                                            <p style={{ fontWeight: "lighter" }}>
                                                                                                For more information on Waterways and Crossings <a href="https://freshwaterfarmplan.co.nz/fwfp-support/adding-waterways-guide/" target="_blank" rel="noreferrer">Click Here</a>
                                                                                            </p>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </>
                                                                            )}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Input className="" type="checkbox" checked={gisLayerDetails.showGISLayer} onChange={handleGISLayerDetails} name="gisLayerDetails" id="gisLayerDetails" />
                                                                        {'   '}<label className="external-map-sub">Show External Waterways Layer</label>
                                                                    </Col>
                                                                </Row>
                                                                <Row style={{ marginTop: "15px" }}>
                                                                    <Col>
                                                                        <label className="external-map-title">Waterway Map Key</label>
                                                                    </Col>
                                                                </Row>
                                                                <Row >
                                                                    <Col><FaSlash color='#0000FF'></FaSlash> <span className="external-map-sub">  = 100% Fenced (or not required)</span></Col>
                                                                </Row>
                                                                <Row >
                                                                    <Col><FaSlash color='#FFA500'></FaSlash> <span className="external-map-sub">  = Not Fully Fenced</span> </Col>
                                                                </Row>

                                                            </Col>
                                                        </Row>
                                                        {waterway.isMapOnly &&
                                                            <>
                                                                <hr />
                                                                <div style={{ marginTop: "10px" }}>
                                                                    {itemTypeListView}
                                                                </div>
                                                            </>}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                        <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block',marginTop:"-25px" }}>
                            <Row>
                                <Col style={{ borderBottom: "1px solid #0d535d" }}>
                                    {toggleSwitch == 'map & details' &&
                                        <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                        <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                    </Button>
                                }
                                    {toggleSwitch == 'details' &&
                                        <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                            <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                        </Button>
                                    }
                                    {
                                        !loading && !waterway.isMapOnly && <Button style={{ marginLeft: "0.5vw" }} onClick={() => handleRiskSummaryOpen()} className="btn btn-risk-summary">Risk and Actions summary</Button>
                                    }
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <Card className="cardNonLeftRadius">
                                        <CardBody>
                                            <Row>
                                                <Col>
                                                    <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                                        <Row>
                                                            <Col>
                                                                <Row>
                                                                    {waterway.isMapOnly &&
                                                                        <Col>
                                                                            <h4>Identify Waterways</h4>
                                                                        </Col>
                                                                    }
                                                                    {!waterway.isMapOnly &&
                                                                        <Col>
                                                                            <h4>Waterways</h4>
                                                                        </Col>
                                                                    }
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="8">
                                                                <Row>
                                                                    <Col>
                                                                        <label className=""><b>Definitions of waterways:</b></label>
                                                                    </Col>
                                                                </Row>
                                                                <Row >
                                                                    <Col  >
                                                                        <ul className="external-map-sub">
                                                                            <li>Ephemeral – an area where water only flows during and shortly after rainfall, e.g. ditch that is dry most of the time, swale.</li>
                                                                            <li>Intermittent – a waterway that ceases to flow for some periods of the year or at least twice every 5 years.</li>
                                                                            <li>Perennial – a waterway that is full or continues to flow throughout the year for all or most years.</li>
                                                                            <li>Groundwater - Groundwater is the water present beneath Earth's surface.</li>
                                                                        </ul>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col>
                                                                <Row>
                                                                    <Col>
                                                                        <label className="external-map-title"><b>External Map Layers</b>&nbsp;&nbsp;&nbsp;
                                                                            <img className="featureIcon" src="/images/info_button_dk.png" data-tooltip-id="my-tooltip-29" onClick={(e) => e.stopPropagation()} /></label>
                                                                        <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                                                            id="my-tooltip-29"
                                                                            place="top"
                                                                            variant="info"
                                                                            render={({ content, activeAnchor }) => (
                                                                                <>
                                                                                    <Row>
                                                                                        <Col>
                                                                                            <p style={{ fontWeight: "lighter" }}>
                                                                                                For more information on Waterways and Crossings <a href="https://freshwaterfarmplan.co.nz/fwfp-support/adding-waterways-guide/" target="_blank" rel="noreferrer">Click Here</a>
                                                                                            </p>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </>
                                                                            )}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                        <Input className="" type="checkbox" checked={gisLayerDetails.showGISLayer} onChange={handleGISLayerDetails} name="gisLayerDetails" id="gisLayerDetails" />
                                                                        {'   '}<label className="external-map-sub">Show External Waterways Layer</label>
                                                                    </Col>
                                                                </Row>
                                                                <Row style={{ marginTop: "15px" }}>
                                                                    <Col>
                                                                        <label className="external-map-title">Waterway Map Key</label>
                                                                    </Col>
                                                                </Row>
                                                                <Row >
                                                                    <Col><FaSlash color='#0000FF'></FaSlash> <span className="external-map-sub">  = 100% Fenced (or not required)</span></Col>
                                                                </Row>
                                                                <Row >
                                                                    <Col><FaSlash color='#FFA500'></FaSlash> <span className="external-map-sub">  = Not Fully Fenced</span> </Col>
                                                                </Row>

                                                            </Col>
                                                        </Row>
                                                        <hr />
                                                        <br />
                                                        {show_SectionComment &&
                                                            <>
                                                                <Row style={{ marginTop: "0.5vh" }}>
                                                                    <Col sm="12">
                                                                        <FormGroup>
                                                                            <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "16px" }}><b>Section Comment</b> <span className="text-lowercase">(add any information around the features, actions, or risks, that have been considered on this page)</span></Label>
                                                                            <Editor handlePastedText={() => false}
                                                                                defaultEditorState={editorState}
                                                                                onEditorStateChange={setEditorState}
                                                                                wrapperClassName="wrapper-class"
                                                                                editorClassName="editor-class"
                                                                                toolbarClassName="toolbar-class"
                                                                                toolbar={
                                                                                    {
                                                                                        options: ['inline'], inline: {
                                                                                            inDropdown: false,
                                                                                            options: ['bold', 'italic', 'underline'],
                                                                                        }
                                                                                    }
                                                                                }
                                                                            />
                                                                        </FormGroup>

                                                                    </Col>
                                                                    <Col sm="12">
                                                                        {savingSectionComment ?
                                                                            <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" disabled>
                                                                                <Row>
                                                                                    <Col sm="8">
                                                                                        <span>
                                                                                            {' '}Saving
                                                                                        </span>
                                                                                    </Col>
                                                                                    <Col sm="4">
                                                                                        <Spinner size="sm">
                                                                                            Saving...
                                                                                        </Spinner>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Button>
                                                                            :
                                                                            <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" size="sm">
                                                                                Save
                                                                            </Button>
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                                <br />
                                                            </>
                                                        }
                                                        <div style={{ marginTop: "10px" }}>
                                                            {nonMapView}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>

                            

                        </Col>
                    </Row>
                </div>
                
            }
            <Modal size="lg" isOpen={itemPopup.showItemPopup} backdrop={false} className="itemPopup">
                <Form>
                    <ModalHeader toggle={handleItemPopupClose} >Add/Edit Item&nbsp;&nbsp;&nbsp;
                        <img className="featureIcon" src="/images/info_button_dk.png" onClick={(e) => showToastMessage(e, "Complete the required details. If you feel the item adds to the farm's biodiversity, then click on that box. If you chose that the item has risk, then complete that detail. Also, complete the additional information section. You can now add any records or photos and describe any achievements already in place for this waterway. Remember to hit Save and then you do the same for all waterways items, one by one.", "idAddEditItem")} /></ModalHeader>
                    <ModalBody>
                        <WaterwayItemCommonTop 
                        handleFormFieldChange={handleFormFieldChange}
                        isNonContiguous={isNonContiguous}
                        masterWaterwayItemList={masterWaterwayItemList.filter(x => x.typeFilter == itemPopupMaptype.markertype && x.id != itemPopup.itemId) }
                        formContiguous={formContiguous} itemPopup={itemPopup} itemList={waterway.itemList} setFormErrors={setFormErrors} Section={waterway.Section} handleLMUChange={handleLMUChange} itemPopupHeader={itemPopupHeader} itemTypeFieldList={itemPopupItemField.itemFieldTypes} itemPopupItemSepcQ={itemPopupItemSepcQ} itemPopupMaptype={itemPopupMaptype} itemPopupBiodiversity={itemPopupBiodiversity} itemPopupRisk={itemPopupRisk}
                            largeEnterpriseDetails={largeEnterpriseDetails} formErrors={formErrors} riskLookupList={riskLookupList}
                            handleItemPopupHeaderChange={handleItemPopupHeaderChange} handleMultiSelectRiskChange={handleMultiSelectRiskChange}
                            handleItemPopupBiodiversity={handleItemPopupBiodiversity}
                            handleItemPopupRisk={handleItemPopupRisk} setRiskLookupList={setRiskLookupList} setItemPopupRisk={setItemPopupRisk}
                            handleMultiSelectEnterpriseChange={handleMultiSelectEnterpriseChange}
                            handleMultiSelectContaminantChange={handleMultiSelectContaminantChange}
                            handleMultiSelectRiskDataGroupChange={handleMultiSelectRiskDataGroupChange}
                            handleMultiSelectActivityGroupChange={handleMultiSelectActivityGroupChange}
                            handleMultiSelectActivitySubGroupChange={handleMultiSelectActivitySubGroupChange} handleMultiSelectCategoryChange={handleMultiSelectCategoryChange}></WaterwayItemCommonTop>
                        <WaterwaysItemSpecView handleAlertPopupOpen={handleAlertPopupOpen} formErrors={formErrors} itemPopupItemField={itemPopupItemField} itemPopupItemSepcQ={itemPopupItemSepcQ}
                            handleItemSepcValueChange={handleItemSepcValueChange} waterwayWidthList={waterway.waterwayWidthList} percentageFencedList={waterway.percentageFencedList} averageRiparianMarginPlantedList={waterway.averageRiparianMarginPlantedList}
                            percentageOfLengthRiparianPlantedList={waterway.percentageOfLengthRiparianPlantedList}
                        >
                        </WaterwaysItemSpecView>
                        {!isNonContiguous && 
                            <>
                                
                            <ItemCommonBottom setImageUploadList={setImageUploadList} imageUploadList={imageUploadList} itemPopup={itemPopup} itemPopupAchievements={itemPopupAchievements}
                                handleItemPopupAchievements={handleItemPopupAchievements}></ItemCommonBottom>
                            </>
                        }
                        
                        
                    </ModalBody>

                    <ItemFooter itemPopup={itemPopup} saving={saving}
                        handleItemDeletePopup={handleItemDeletePopup}
                        handleItemSubmit={handleItemSubmit}
                        handleItemPopupClose={handleItemPopupClose}
                        handleOpenActionPopup={handleOpenActionPopup}
                        handleOpenMaintenancePlanPopup={handleOpenMaintenancePlanPopup}>
                    </ItemFooter>
                </Form>
            </Modal>
            <Modal isOpen={itemDeletePopup.showItemDeletePopup}>
                <ModalHeader toggle={handleItemDeletePopupClose} >Archive the item</ModalHeader>
                <ModalBody>
                    Do you want to archive the item ?
                </ModalBody>
                <ModalFooter>
                    {itemDeletesaving ?
                        <>
                            <Button onClick={deleteItem} color="primary" disabled>
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Saving
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Saving...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={deleteItem} color="primary">
                                Yes
                            </Button>{' '}
                        </>
                    }
                    <Button color="danger" onClick={handleItemDeletePopupClose}>No</Button>
                </ModalFooter>
            </Modal>

            {actionPopup.showActionPopup && !actionPopup.isHavingItemBasedAction && <Action width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={waterway.itemList} redirectPage="/waterways" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleActionClose} itemTypeId={actionPopup.itemTypeId} sectionName={waterway.Section} sectionId={waterway.itemTypes[0].sectionId} itemId={actionPopup.itemId} itemName={actionPopup.itemName}
                showActionPopupModal={actionPopup.showActionPopup} actionId={actionPopup.actionId} itemTypeSelect={waterway.itemTypes} itemTypeDisabled={true}></Action>}

            {actionPopup.showActionPopup && actionPopup.isHavingItemBasedAction && <ItemBasedAction width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={waterway.itemList} redirectPage="/waterways" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleActionClose} itemTypeId={actionPopup.itemTypeId} sectionName={waterway.Section} sectionId={waterway.itemTypes[0].sectionId} itemId={actionPopup.itemId} itemName={actionPopup.itemName}
                showActionPopupModal={actionPopup.showActionPopup} actionId={actionPopup.actionId} itemTypeSelect={waterway.itemTypes} itemTypeDisabled={true} wholeFarmAction={false} ></ItemBasedAction>}

            {wholeFarmActionPopup.showActionPopup && <Action width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={waterway.itemList} redirectPage="/waterways" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleWholeActionClose} itemTypeId={wholeFarmActionPopup.itemTypeId} sectionName={waterway.Section} sectionId={waterway.itemTypes[0].sectionId} itemId={wholeFarmActionPopup.itemId} itemName={wholeFarmActionPopup.itemName}
                showActionPopupModal={wholeFarmActionPopup.showActionPopup} actionId={wholeFarmActionPopup.actionId} itemTypeSelect={waterway.outlineItemTypes} itemTypeDisabled={true} wholeFarmAction={true}></Action>}

            {maintenancePlanPopup.showMaintenancePlanPopup && <MaintenancePlan handleMaintenancePlanClose={handleMaintenancePlanClose}
                showMaintenancePlanPopupModal={maintenancePlanPopup.showMaintenancePlanPopup}
                actionId={maintenancePlanPopup.actionId} itemId={maintenancePlanPopup.itemId} itemName={maintenancePlanPopup.itemName} itemTypeId={maintenancePlanPopup.itemTypeId}
                itemTypeSelect={waterway.itemTypes} sectionName={waterway.Section} redirectPage="/waterways">
            </MaintenancePlan>}

            {riskSummaryPopup.showriskSummary && <RiskSummary section={waterway.SectionObj} sectionId={waterway.itemTypes[0].sectionId} riskSummaryPopup={riskSummaryPopup} handleRiskSummaryClose={handleRiskSummaryClose}></RiskSummary>}

            <Modal isOpen={alertPopup.showAlertPopup}>
                <ModalHeader toggle={handleAlertPopupClose} >Alert</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <Label className="label">{alertPopup.message}</Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Input type="checkbox" checked={alertPopup.isDisregarded} onChange={(e) => setAlertPopup({ ...alertPopup, isDisregarded: !alertPopup.isDisregarded })} name="isDisregarded" id="isDisregarded" />
                            <Label style={{ marginLeft: "10px" }}>Disregard this alert</Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Label for="disregardDescription">Why disregard this alert</Label>
                            <Input type="textarea" onChange={(e) => setAlertPopup({ ...alertPopup, disregardDescription: e.target.value })} value={alertPopup.disregardDescription} name="disregardDescription" id="disregardDescription" />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    {
                        alertPopup.isDisregarded && <Button color="success" onClick={handleAlertPopupSave}>Ok</Button>
                    }
                </ModalFooter>
            </Modal>
        </div>
    )
}
export default Waterways;